/**
 * API DocsHomeApisInvolved Section Template
 * By Srinivasa Upputuri <supputuri@svb.com> (www.svb.com)
 * Summary
 * This component renders Apis Involved section to the DocsHome
 */
import React, { useEffect, useState } from 'react';
// import Loading from '@svb/api-loading-component/dist/components';
import { SVBAPIsSection } from '@svb/portal-ui-react-components';
import useFilteredCatalogLatestVersion from '../../helpers/utilityCustomHooks/useFilteredCatalogLatestVersion';
import { buildCardJsonForAPis } from '../../helpers/utilityFunctions';

/**
 * DocsHomeWidgets
 * @param contentUrl: url of the widgets content
 * @param title: title of this Widget
 * @returns DocsHomeApis Involved Cards Section
 */
const DocsHomeApisInvolved = ({ dataTestId, testMockContent, ...props }) => {
  const { apiSectionTitle } = props;
  const [mounted, setMounted] = useState(false);
  const [apisSectionLabelState, setapisSectionLabelState] = useState('Commercial Banking APIs');
  const filteredCatalogLatestVersion = useFilteredCatalogLatestVersion();
  const apiCardJson = dataTestId
    ? testMockContent
    : buildCardJsonForAPis(filteredCatalogLatestVersion);

  useEffect(() => {
    if (apiSectionTitle) {
      setapisSectionLabelState(apiSectionTitle);
    }
    setMounted(true);
  }, []);

  const LearnMoreCardLabel = () => (
    <span className='learn-more-label'>
      {'Learn More'}
      <i className='fa-solid fa-arrow-right right-arrow-icon' />
    </span>
  );
  const apiCardsData = {
    apiSectionlabel: apisSectionLabelState, //title for molecule
    apisJson: apiCardJson?.response, //json from service
    cardsOption: {
      extraClasses: 'mx-3 mb-3 mt-6',
      //options for API cards section
      cardOptions: {
        titleSeparator: false,
        overrideLearnMoreElement: LearnMoreCardLabel(),
        logo:{
          size: 64
        }
      },
    },
  };

  return !mounted ? (
    <></>
  ) : (
    <section className='container svb-container-fixed'>
      <SVBAPIsSection apiCardsData={apiCardsData} />
    </section>
  );
};
export default DocsHomeApisInvolved;
